import styled from 'styled-components';

export const AuthSwitchLinkContainer = styled.p`
  margin-top: 2rem;

  .text {
    color: ${({theme}) => theme.colors.text};
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
  }

  .link-text {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
  }
`;
